const i = (t, n, o = "...") => !t || t.length <= n ? t : `${t.substring(0, n)}${o}`, r = (t) => !!t && t.trim() !== "", l = (t) => !!t && String(t).toLowerCase() !== "false" && t !== "0", g = ({
  text: t,
  /** Lenght of the step for reducing the size */
  lengthStep: n,
  /** Size reduction for each step  */
  sizeStep: o = 0.1,
  /** Minimum size */
  min: e = 0.5
}) => {
  const c = (t || "").length, s = 1 - Math.floor(c / n) * o;
  return s < e ? e : s;
}, h = `  
`, p = (t, n = "-") => t.join(n), u = (t = "") => t === "" ? "" : ` ${t}`;
export {
  p as buildKey,
  g as calcResponsiveSize,
  r as isNotEmpty,
  h as newline,
  l as toBoolean,
  i as truncate,
  u as withSpace
};
